/**
 * @file 问卷结果统计
 * @author liudy
 * @see http://api.umucdn.cn/project/106/wiki
 */

import Api from '../../path';
import { PollType } from '@umu/umu-types';
import { fetchData, fetchDataSync } from '@umu/umu-fetch';

export interface IGetPollResultStatInput {
    parent_id: number; // int 作业问卷ID
    parent_type: PollType; // int 1、保存作业多维度评价问卷模板 2、保存作业多维度评价问卷
    obj_id: number; // int 评价对象ID，比如学生提交作业的homework_id
    question_ids?: string; // string 选填，题目id，多个question_id用逗号隔开
    other_content_size?: number; // int 选填，开放式问题和选择题“其他”选项下返回的文本条数，默认10
}

// tslint:disable-next-line:max-line-length
export const getPollResultStat = (data: IGetPollResultStatInput): Promise<IResponse<IServerStatResultInfo>> => {
    return fetchData(Api.POLL_RESULT_STAT, data).then((res: IResponse<IServerStatResultInfo>) => {
        return res;
    });
};

export const getPollResultStatSync = fetchDataSync(getPollResultStat);
